/* eslint-disable react-hooks/exhaustive-deps */
import React, {Fragment} from 'react';

import {ChevronLeft, Fullscreen, FullscreenExit, Menu} from '@mui/icons-material';
import {createTheme, styled, ThemeProvider} from '@mui/material/styles';
import {
    Button,
    CssBaseline,
    Divider,
    Drawer,
    Fab,
    Grid,
    Hidden,
    IconButton,
    Link,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Skeleton,
    Slide,
    Toolbar,
    Tooltip,
    Typography,
    Zoom
} from '@mui/material';

import {SnackbarProvider} from 'notistack';

import logo from './logo_blue.png';
import {SkeletonText} from '../../Core/LoadingAnimation'

import {matchPath, Redirect, useHistory} from 'react-router-dom'

import isFullScreenContext from './isFullScreenContext'

import clsx from 'clsx';
import {APP_STATE, LOGIN_STATES} from "../../Store/actionTypes";

import {faSignOutAlt, faSpinner, faUserCog} from "@fortawesome/pro-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {AppTitle, AppTitleTemplate, CompanyName, Version} from "../../Config";
import DefaultValuePropagator from "../../Core/Propagator/DefaultValuePropagator";
import MuiAppBar from '@mui/material/AppBar'
import {makeStyles} from "@mui/styles";
import Box from "@mui/material/Box";

export const pageTheme = createTheme({
    overrides: {
        MuiTableCell: {
            body: {
                color: '#7a7b7f',
            },
            head: {
                color: '#061A28FF',
            }
        },
        MuiTab: {
            root: {
                minWidth: "0px",
                '@media (min-width: 0px)': {
                    minWidth: 0
                }
            }
        }
//        MuiDialogContent: {
//            root: {
//                backgroundColor: '#f8f8f8',
//            }
//        },
    },
    palette: {
        primary: {
            light: 'rgba(6,26,40,0.4)',
            main: '#061A28FF',
            dark: '#061A28FF',
            contrastText: '#fff',
            action: 'rgba(6,26,40,0.1)',
            lightGrey: '#FBFBFF',
        },
        secondary: {
            light: '#e9b340',
            main: 'rgb(101,122,151)',
            dark: '#7f5800',
            contrastText: '#000',
        },
        badge: {
            main: '#e9b340',
            contrastText: '#fff',
        },
    },
});

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({theme, open}) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));


const useStyles = makeStyles({
    root: {
        display: 'flex',
        height: '100%',
    },
    appBar: {
        zIndex: pageTheme.zIndex.drawer + 1,
        transition: pageTheme.transitions.create(['width', 'margin'], {
            easing: pageTheme.transitions.easing.sharp,
            duration: pageTheme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: pageTheme.transitions.create(['width', 'margin'], {
            easing: pageTheme.transitions.easing.sharp,
            duration: pageTheme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
    drawerOpen: {
        width: drawerWidth,
        transition: pageTheme.transitions.create('width', {
            easing: pageTheme.transitions.easing.sharp,
            duration: pageTheme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        transition: pageTheme.transitions.create('width', {
            easing: pageTheme.transitions.easing.sharp,
            duration: pageTheme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: pageTheme.spacing(7) + 1,
        [pageTheme.breakpoints.up('sm')]: {
            width: pageTheme.spacing(9) + 1,
        },
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...pageTheme.mixins.toolbar,
    },
    content: {
        flexGrow: 1,
        padding: pageTheme.spacing(3),
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
    },
    drawerHead: {},
    drawerHeadOpen: {
        transition: pageTheme.transitions.create('width', {
            easing: pageTheme.transitions.easing.sharp,
            duration: pageTheme.transitions.duration.enteringScreen,
        }),
    },
    drawerHeadClose: {
        transition: pageTheme.transitions.create('width', {
            easing: pageTheme.transitions.easing.sharp,
            duration: pageTheme.transitions.duration.leavingScreen,
        }),
    },
    title: {
        flexGrow: 1,
    },
});

/* istanbul ignore next */
export default function Template(props) {

    const classes = useStyles();
    const theme = pageTheme;

    const [open, setOpen] = React.useState(false);
    const [showSmallText] = React.useState(localStorage.getItem('view-option-show-caption') === String(true));

    const [expandedView, setExpandedView] = React.useState(localStorage.getItem('view-option-expanded-view') === String(true));

    let history = useHistory();

    function handleDrawerOpen() {
        setOpen(true);
    }

    function handleDrawerClose() {
        setOpen(false);
    }

    function toggleView() {
        localStorage.setItem('view-option-expanded-view', String(!expandedView))
        setExpandedView(!expandedView);
    }

    let renderMenuItem = React.useCallback((j, k, c) => {
        return props.accessCheck(j) && !j.isHidden && <Fragment key={k}>
            {j.preDivider && <ListItem divider key={c}/>}
            <Tooltip title={open ? '' : <Typography> {j.label} </Typography>}
                     placement="right"
            >
                <ListItem button
                          onClick={() => {
                              if (j.lazyLoader) {
                                  history.push(j.link);
                                  props.setHeader(j.label, j.icon);
                                  document.title = j.label + ' - ' + AppTitle

                              }
                              handleDrawerClose()
                          }}
                          disabled={!j.lazyLoader}
                          selected={!!matchPath(props.currentPath, {
                              path: j.link,
                              exact: false,
                              strict: true
                          })}
                >
                    <ListItemIcon
                        style={{color: theme.palette.primary.dark, maxWidth: '72px'}}>
                        <Grid container direction="column" alignItems="flex-start">
                            <Grid item>
                                {j.icon}
                            </Grid>
                            <Slide in={!open && showSmallText} direction={"left"} mountOnEnter
                                   unmountOnExit>
                                <Grid item>
                                    <Typography noWrap variant="caption">
                                        <div style={{
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            maxWidth: '60px'
                                        }}>
                                            {j.label}
                                        </div>
                                    </Typography>
                                </Grid>
                            </Slide>
                        </Grid>
                    </ListItemIcon>
                    <ListItemText primary={j.label}
                        //secondary={i.label}
                                  style={{color: theme.palette.primary.dark}}/>
                </ListItem>
            </Tooltip>
            {j.postDivider && <ListItem divider key={c}/>}
        </Fragment>;
    }, [props.accessCheck, props.setHeader, props.currentPath, showSmallText, open]);

    return (<ThemeProvider theme={pageTheme}>
        <DefaultRedirect currentPath={props.currentPath} components={props.components}
                         loginState={props.loginState}/>
        <div className={classes.root} style={{flex: "1 0 auto"}}>
            <CssBaseline/>
            <Slide direction="down" in={!expandedView} mountOnEnter unmountOnExit>
                <AppBar
                    position="fixed"
                    className={clsx(classes.appBar, {
                        [classes.appBarShift]: open,
                    })}
                >
                    <Toolbar>
                        {open ? <IconButton
                            color="inherit"
                            aria-label="close drawer"
                            onClick={handleDrawerClose}
                            edge="start"
                            className={clsx(open && classes.hide)}
                        >
                            <ChevronLeft/>
                        </IconButton> : <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            onClick={handleDrawerOpen}
                            edge="start"
                            className={clsx(open && classes.hide)}
                        >
                            <Menu/>
                        </IconButton>}
                        <Typography variant="h6" noWrap className={classes.title}>
                            <span style={{paddingLeft: '1.5rem', color: theme.palette.primary.contrastText}}>
                                {(props.appState === APP_STATE.INITIALISING || props.loginState === LOGIN_STATES.TRY_LOGIN) &&
                                    <FontAwesomeIcon icon={faSpinner} pulse fixedWidth/>}
                                {props.appState === APP_STATE.INITIALISED && props.loginState !== LOGIN_STATES.TRY_LOGIN && props.header.icon}
                            </span>
                            <span style={{paddingLeft: '.5rem', color: theme.palette.primary.contrastText}}>
                                {props.appState === APP_STATE.INITIALISING && 'Initialising'}
                                {props.appState === APP_STATE.INITIALISED && props.loginState === LOGIN_STATES.TRY_LOGIN && 'Authenticating User'}
                                {props.appState === APP_STATE.INITIALISED && props.loginState !== LOGIN_STATES.TRY_LOGIN && props.header.title}
                            </span>
                        </Typography>
                        <img src={logo} width={35} onClick={() => window.location.href = '/'}
                             style={{marginRight: '1rem'}} alt={'BioRetis Logo'}/>
                        <Hidden smDown>
                            <Typography variant={"h6"} style={{
                                fontFamily: 'Space Mono',
                                color: theme.palette.primary.contrastText,
                                marginRight: '2rem'
                            }} onClick={() => window.location.href = '/'}>
                                {AppTitleTemplate}
                            </Typography>
                        </Hidden>
                        {props.loginState === LOGIN_STATES.LOGGED_IN &&
                            <>
                                <Hidden lgDown>
                                    <Tooltip title={
                                        <Typography> {'Expand View'} </Typography>}
                                             placement="bottom"
                                    >
                                        <IconButton
                                            aria-label="account of current user"
                                            aria-controls="menu-appbar"
                                            aria-haspopup="true"
                                            color="inherit"
                                            onClick={toggleView}
                                            size={"large"}
                                        >
                                            <Fullscreen size={"large"}/>
                                        </IconButton>
                                    </Tooltip>
                                </Hidden>
                                <Tooltip title={<Typography> User Settings </Typography>}
                                         placement="bottom"
                                >
                                    <IconButton
                                        aria-label="account of current user"
                                        aria-controls="menu-appbar"
                                        aria-haspopup="true"
                                        color="inherit"
                                        onClick={DefaultValuePropagator(history.push)('/page/user/settings')}
                                    >
                                        <FontAwesomeIcon icon={faUserCog} fixedWidth/>
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title={<Typography> LogOut </Typography>}
                                         placement="bottom"
                                >
                                    <IconButton
                                        aria-label="account of current user"
                                        aria-controls="menu-appbar"
                                        aria-haspopup="true"
                                        color="inherit"
                                        onClick={DefaultValuePropagator(history.push)('/page/logout')}
                                    >
                                        <FontAwesomeIcon icon={faSignOutAlt} fixedWidth/>
                                    </IconButton>
                                </Tooltip>
                            </>
                        }
                        {props.loginState === LOGIN_STATES.NOT_LOGGED_IN &&
                            <Button color="inherit"
                                    onClick={DefaultValuePropagator(history.push)('/page/login')}>Login</Button>
                        }
                    </Toolbar>
                </AppBar>
            </Slide>
            <Drawer
                open={open}
                onClose={handleDrawerClose}
                className={clsx(classes.drawer, {
                    [classes.drawerOpen]: open,
                    [classes.drawerClose]: !open,
                })}
                classes={{
                    paper: clsx({
                        [classes.drawerOpen]: open,
                        [classes.drawerClose]: !open,
                    }),
                }}
            >
                <div className={classes.toolbar}>
                    {open &&
                        <IconButton onClick={handleDrawerClose}>
                            <ChevronLeft/>
                        </IconButton>

                    }
                    {!open &&
                        <IconButton onClick={handleDrawerOpen}>
                            <Menu/>
                        </IconButton>
                    }
                </div>
                <Divider/>
                <List>
                    {props.appState === APP_STATE.INITIALISED && props.loginState !== LOGIN_STATES.TRY_LOGIN &&
                        <>
                            {props.components.map((i, c) => {
                                if (i.type === 'item') {
                                    return renderMenuItem(i, c, c);
                                }

                                if (props.accessCheck(i) && i.type === 'collection') {
                                    return <Fragment key={c}>
                                        {!i.isPlainCollection &&
                                            <>
                                                <Zoom in={open} unmountOnExit mountOnEnter>
                                                    <ListItem className={clsx(classes.drawerHead, {
                                                        [classes.drawerHeadOpen]: open,
                                                        [classes.drawerHeadClose]: !open,
                                                    })}
                                                    >
                                                        <ListItemIcon> {i.icon} </ListItemIcon>
                                                        <ListItemText secondary={i.label}/>
                                                    </ListItem>
                                                </Zoom>
                                            </>
                                        }
                                        {
                                            i.children.map((d, k) => renderMenuItem(d, k, c))
                                        }
                                    </Fragment>
                                }
                                return null;
                            })}
                            {expandedView &&
                                <>
                                    {props.loginState === LOGIN_STATES.LOGGED_IN &&
                                        <>
                                            <ListItem divider/>
                                            <Tooltip title={<Typography> User Settings </Typography>}
                                                     placement="right">
                                                <ListItem button
                                                          onClick={DefaultValuePropagator(history.push)('/page/user/settings')}>
                                                    <ListItemIcon style={{color: theme.palette.primary.dark}}>
                                                        <FontAwesomeIcon icon={faUserCog} fixedWidth/>
                                                    </ListItemIcon>
                                                    <ListItemText primary={'User Settings'}
                                                                  style={{color: theme.palette.primary.dark}}/>
                                                </ListItem>
                                            </Tooltip>
                                            <Tooltip title={<Typography> LogOut </Typography>}
                                                     placement="right">
                                                <ListItem button
                                                          onClick={DefaultValuePropagator(history.push)('/page/logout')}>
                                                    <ListItemIcon style={{color: theme.palette.primary.dark}}>
                                                        <FontAwesomeIcon icon={faSignOutAlt} fixedWidth/>
                                                    </ListItemIcon>
                                                    <ListItemText primary={'LogOut'}
                                                                  style={{color: theme.palette.primary.dark}}/>
                                                </ListItem>
                                            </Tooltip>
                                        </>
                                    }
                                    <ListItem divider/>
                                    <Tooltip title={<Typography> Compress View </Typography>}
                                             placement="right">
                                        <ListItem button onClick={toggleView}>
                                            <ListItemIcon style={{color: theme.palette.secondary.dark}}>
                                                <FullscreenExit/>
                                            </ListItemIcon>
                                            <ListItemText primary={'Compress View'}
                                                          style={{color: theme.palette.secondary.dark}}/>
                                        </ListItem>
                                    </Tooltip>
                                </>
                            }
                        </>
                    }
                    {(props.appState === APP_STATE.INITIALISING || props.loginState === LOGIN_STATES.TRY_LOGIN) &&
                        Array(8).fill('').map((_, i) =>
                            <ListItem key={i} button>
                                <ListItemIcon>
                                    <Skeleton variant="circle" width={30} height={30}/>
                                </ListItemIcon>
                                <ListItemText primary={<Skeleton variant={'text'} width={120} height={15}/>}/>
                            </ListItem>
                        )
                    }

                    {open &&
                        <>
                            <ListItem divider/>
                            {/*   <ListItem
                            button
                            onClick={() => {
                                localStorage.setItem('view-option-show-caption', String(!showSmallText))
                                setShowSmallText(!showSmallText)
                            }}
                        >
                            <ListItemIcon><p/></ListItemIcon>
                            <ListItemText primary="Show caption" secondary={"Show text in menu"}
                                          style={{color: theme.palette.primary.dark}}/>
                            <ListItemSecondaryAction>
                                <Switch
                                    size={'small'}
                                    edge="end"
                                    checked={showSmallText}
                                    color="primary"
                                    onClick={() => {
                                        localStorage.setItem('view-option-show-caption', String(!showSmallText))
                                        setShowSmallText(!showSmallText)
                                    }}
                                />
                            </ListItemSecondaryAction>
                        </ListItem>*/}
                        </>
                    }

                    <ListItem className={clsx(classes.drawerHead, {
                        [classes.drawerHeadOpen]: open,
                        [classes.drawerHeadClose]: !open,
                    })}
                    >
                        <ListItemIcon><p/></ListItemIcon>
                        <ListItemText secondary={'Version: ' + Version}/>
                    </ListItem>
                </List>
            </Drawer>

            <div className={classes.content} style={{minHeight: '100%'}}>
                <Slide in={!expandedView} direction={"down"} mountOnEnter unmountOnExit>
                    <div id={'toolbar'} className={classes.toolbar}/>
                </Slide>
                <Slide in={expandedView} direction={"down"} mountOnEnter unmountOnExit>
                    <Box sx={{'& > :not(style)': {m: 1}}}>
                        <Tooltip title={<Typography> Menu </Typography>}>
                            <Fab aria-label="compress" size={"small"}>
                                <Menu onClick={handleDrawerOpen}/>
                            </Fab>
                        </Tooltip>
                        <Tooltip title={<Typography> Compress View </Typography>}>
                            <Fab aria-label="menu" size={"small"}>
                                <FullscreenExit onClick={toggleView}/>
                            </Fab>
                        </Tooltip>
                    </Box>
                </Slide>

                <main style={{flex: 1}}>
                    <SnackbarProvider maxSnack={5}
                                      anchorOrigin={{
                                          vertical: 'bottom',
                                          horizontal: 'right',
                                      }}
                    >
                        <Grid container
                              spacing={3}
                              direction="row"
                              justifyContent="center"
                              alignItems="baseline"
                              style={{height: '100%'}}
                        >
                            <Grid item xs={12} sm={12} xl={expandedView ? 12 : 10} style={{
                                height: '100%', transition: theme.transitions.create("all", {
                                    easing: theme.transitions.easing.sharp,
                                    duration: theme.transitions.duration.leavingScreen
                                })
                            }}>

                                <ErrorBoundary history={history}>
                                    <isFullScreenContext.Provider value={expandedView}>
                                        {(props.appState === APP_STATE.INITIALISING || props.loginState === LOGIN_STATES.TRY_LOGIN) &&
                                            <SkeletonText rows={25} withHeadline/>
                                        }
                                        {props.appState === APP_STATE.INITIALISED && props.loginState !== LOGIN_STATES.TRY_LOGIN &&
                                            props.children
                                        }
                                    </isFullScreenContext.Provider>
                                </ErrorBoundary>

                            </Grid>
                        </Grid>
                    </SnackbarProvider>
                </main>
                <Hidden smDown>
                    <Slide direction="up" in={!expandedView} mountOnEnter unmountOnExit>
                        <Grid container
                              spacing={0}
                              direction="row"
                              justifyContent="center"
                              alignItems="center"
                              alignContent="center"
                              align={"center"}
                              style={{
                                  flexShrink: 0,
                              }}
                        >
                            <Grid item xs={12} align={"center"}>
                                <hr/>
                            </Grid>
                            <div style={{height: "70px"}}/>
                            <Grid item xs={5} align={"center"}>
                                <small>
                                    <span>All Rights Reserved ©</span>
                                    <span>{" "}{CompanyName}</span>
                                    <span>{" "}{new Date().getFullYear()}</span>
                                </small>
                            </Grid>
                            <Grid item xs={2} align={"center"}>
                                <Link onClick={() => window.open('https://bioretis.com', '_blank')}
                                      style={{textDecoration: 'none'}}>
                                    <Grid container alignItems={'center'} justifyContent={'center'} direction={'column'}
                                          spacing={3}>
                                        <img src={logo} height={"25px"} alt={"logo"}/>
                                        <small>
                                            <span> www.bioretis.com </span>
                                        </small>
                                    </Grid>
                                </Link>

                            </Grid>
                            <Grid item xs={5} align={"center"}>
                                <small>
                                    <a href={"/page/impress"}
                                       onClick={DefaultValuePropagator(history.push)('/page/impress')}>Legal
                                        notice</a>
                                    <span> | </span>
                                    <a href={"/page/privacy"}
                                       onClick={DefaultValuePropagator(history.push)('/page/privacy')}>Privacy</a>
                                </small>
                            </Grid>
                        </Grid>
                    </Slide>
                </Hidden>
            </div>
        </div>
    </ThemeProvider>)
}

export class ErrorBoundary extends React.Component {

    constructor(props) {
        super(props);
        this.state = {error: null, info: null};
        props.history.listen(() => this.clearError());
    }

    componentDidCatch(error, info) {
        console.log({error, info});
        this.setState({error: error, info: info});
    }

    clearError() {
        this.setState({error: null, info: null});
    }

    render() {
        if (this.state.error) {
            return <>
                <h1>Something went wrong.</h1>
                <small>
                    {this.state.error.message}
                </small>
            </>;
        } else {
            return this.props.children;
        }
    }
}


function DefaultRedirect({components, loginState, currentPath}) {
    if (components.length === 0) {
        return <></>;
    }

    let pages = components.map(e => {
        if (e.type === 'collection') {
            return e.children;
        }
        return e;
    }).flat();

    let defaultComponent = pages.find(e => e.isDefault(loginState));

    if ([LOGIN_STATES.LOGGED_IN, LOGIN_STATES.NOT_LOGGED_IN].includes(loginState)) {
        if (currentPath === '/' && defaultComponent) {
            return <Redirect to={defaultComponent.link}/>;
        }
    }

    return <></>;
}
